import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderWidth: 4,
  borderColor: (p) => p.palette.grey[50],
};

export const header: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const dashed: SxStyle = {
  borderStyle: 'solid',
  color: (p) => p.palette.grey[300],
};

export const descriptionWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,

  '.MuiGrid-root .MuiDivider-root:last-of-type ': {
    display: 'none',
  },
};
